<template>
  <div class="animated fadeIn">
    <div>
      <b-row>
        <b-col lg="6" sm="12" class="dashboard-wrapper">
          <b-card>
            <template v-slot:header>
              <h5>Desk Collection - Pembayaran Terakhir</h5>
            </template>
            <p>Upload 1 Excel dengan 1 kolom saja berisikan Nomor Faktur</p>
            <p>Excel akan diisi dengan tanggal dan nominal pembayaran terakhir, serta status Nomor Faktur tersebut</p>
            <div class="d-flex align-items-center">
              <!-- Hidden file input -->
              <input
                ref="fileInput"
                type="file"
                class="d-none"
                @change="handleFileChange"
              />
              <!-- Upload Button -->
              <b-button
                variant="pgiBtn"
                class="sms-wrapper-btn"
                @click="$refs.fileInput.click()"
              >
                <i class="fa fa-upload mr-2"></i>
                Upload
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- Modal Konfirmasi -->
      <b-modal
        id="modal-upload-confirm"
        title="Confirm Download Excel"
        @hide="onCloseModal"
        hide-footer
        centered
      >
        <div v-if="!isLoading && !fileDownloadUrl">
          <p>Apakah Anda yakin ingin mendownload Excel ini?</p>
          <div class="d-flex justify-content-end">
            <b-button variant="secondary" @click="onCloseModal">Batal</b-button>
            <b-button variant="primary" class="ml-2" @click="startUpload">Download</b-button>
          </div>
        </div>

        <div v-else-if="isLoading" class="text-center">
          <b-spinner small type="grow" />
          <p class="mt-2">Sedang memproses, mohon menunggu...</p>
        </div>

        <div v-else-if="fileDownloadUrl">
          <p>Silahkan download dengan klik tombol dibawah ini :</p>
          <b-button
            :href="fileDownloadUrl"
            variant="primary"
            download
            target="_blank"
          >
            <i class="fa fa-download mr-2"></i> Download
          </b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      selectedFile: null,
      fileDownloadUrl: "",
      isLoading: false,
    };
  },
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.selectedFile = file;
        this.fileDownloadUrl = ""; // reset
        this.$bvModal.show("modal-upload-confirm");
      }
    },
    startUpload() {
      if (!this.selectedFile) {
        this.$helper.toastErr(this, "File belum dipilih");
        return;
      }
      this.isLoading = true;
      const formData = new FormData();
      formData.append("file", this.selectedFile);
      this.$axios
        .post(`fill-excel/latest-payment-dc?file`, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${this.getToken()}`,
          },
        })
        .then((response) => {
          this.$helper.toastSucc(this, "Upload berhasil!");
          this.fileDownloadUrl = this.$baseFilePath + response.data.name;
        })
        .catch((error) => {
          console.error("Upload gagal:", error);
          const reason = "Terjadi kesalahan saat upload";
          this.$helper.toastErr(this, reason);
          this.$bvModal.hide("modal-upload-confirm");
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onCloseModal(bvEvent) {
        this.$bvModal.hide("modal-upload-confirm");
        if (bvEvent.trigger === 'headerclose' || bvEvent.trigger === 'backdrop') {
        this.selectedFile = null;
        this.fileDownloadUrl = "";
        }
    },
    getToken() {
      return localStorage.getItem("token");
    },
  },
};
</script>
